<template lang="pug">
  Auth(@loggedIn="onLoggedIn"
    :redirectWithLoginFailed="true")
    Header(:content="headerContent")
    div.wrap-lisence-activation
      ModuleLicenseActivation
</template>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";

.wrap-lisence-activation {
  width: 100%;
  min-height: 100vh;
}
</style>

<script>
import database from '@/database'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapStateAuth } = createNamespacedHelpers('auth')
import Auth from '@/components/shared/Auth'
import Header from '@/components/shared/Header.vue'
import ModuleLicenseActivation from '@/components/module/ModuleLicenseActivation'

export default {
  components: {
    Auth, Header, ModuleLicenseActivation
  },
  data () {
    return {
      headerContent: {
        title: 'Home',
        left: {
          icon: 'mdi-close',
          action: () => {}
        },
        right: {
          label: 'Save',
          color: '#1976d2',
          action: () => {}
        }
      }
    }
  },
  computed: {
    ...mapStateAuth(['uid'])
  },
  methods: {
    async onLoggedIn () {
    }
  }
}
</script>
